// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import { AnimatedView, StatsCard, WorkProgress } from "../../components";
import { Redirect, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";

import DatetimeRangePicker from "react-bootstrap-datetimerangepicker";
import moment from "moment";
import { Button } from "react-bootstrap";

import "./home.css";

import Picky from "react-picky";
import "react-picky/dist/picky.css"; // Include CSS

var BarChart = require("react-d3-components").BarChart;

var BarData = [];
let salesAmt="";
var isLoading = "false";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSites: [],
      dashboardData: {},
      loading: false,
      startDate: moment().subtract(6, "days"),
      lastStartDate: "",
      endDate: moment(),
      lastEndDate: "",
      arrangeBy: "days",
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      rangesByMonth: {
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 3 Months': [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 6 Months': [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Last 12 Months': [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
    };

    this.handleDateEvent = this.handleDateEvent.bind(this);
    this.handleSiteChange = this.handleSiteChange.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
  }

  handleFilterData() {
    let seletedIDs = this.state.selectedSites.map((sVal, index) => sVal.siteID);
    const {
      actions: { getDashobardData }
    } = this.props;

    let startDate = moment(this.state.startDate).format("YYYY-MM-DD 00:00:00");
    let endDate = moment(this.state.endDate).format("YYYY-MM-DD 23:59:59");
    getDashobardData({
      siteIDs: seletedIDs,
      graphDateRange: "dateRange",
      startDate: startDate,
      endDate: endDate,
      arrangeBy: this.state.arrangeBy
    });
  }

  handleSiteChange(event, data) {
    this.setState({
      selectedSites: event
    });
  }

  handleDateEvent(event, picker) {
    event.preventDefault();
    this.setState({
      startDate: picker.startDate,
      endDate: picker.endDate
    });

    if(this.state.lastStartDate !== picker.startDate || this.state.lastEndDate !== picker.endDate) {
      const {
        actions: { getDashobardData }
      } = this.props;
      let seletedIDs = this.state.selectedSites.map((sVal, index) => sVal.siteID);
      let startDate = moment(picker.startDate).format("YYYY-MM-DD 00:00:00");
      let endDate = moment(picker.endDate).format("YYYY-MM-DD 23:59:59");

      getDashobardData({
        siteIDs: seletedIDs,
        graphDateRange: "dateRange",
        startDate: startDate,
        endDate: endDate,
        arrangeBy: this.state.arrangeBy
      });
    }
  }

  componentDidMount() {
    const {
      actions: { getSiteList }
    } = this.props;

    getSiteList({ page: 0 });

    if (this.props.error) {
      this.setState({ loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dashboardData) {
      this.setState({ dashboardData: nextProps.dashboardData });
    }

    if (
      !isEmpty(nextProps.siteList) &&
      nextProps.siteList.length > 0 &&
      nextProps.siteList != this.state.siteList
    ) {
      this.setState({
        siteList: nextProps.siteList,
        selectedSites: nextProps.siteList
      });

      const {
        actions: { getDashobardData }
      } = this.props;

      let seletedIDs = nextProps.siteList.map((sVal, index) => sVal.siteID);

      let startDate = moment(this.state.startDate).format(
        "YYYY-MM-DD 00:00:00"
      );
      let endDate = moment(this.state.endDate).format("YYYY-MM-DD 23:59:59");
      this.setState({
        lastStartDate: this.state.startDate,
        lastEndDate: this.state.endDate
      })
      getDashobardData({
        siteIDs: seletedIDs,
        graphDateRange: "dateRange",
        startDate: startDate,
        endDate: endDate
      });
    }
  }

  tooltipBar(x, y, y0) {
    return y == 0 ? " Transactions : " + y0 : " Sales : " + y0;
  }

  toDollars=( nValue, nWide )=> {
    var s= nValue.toFixed(2);
    let j;
    for( j=6; j<15; j+=4 ) {  // insert commas
        if ( s.length > j ) { 
            s= s.substr(0,s.length-j)+','+ s.substr(s.length-j);
        }
    }
    s= '$'+s;  // leading dollar sign
    if ( !isNaN(nWide) ) { // parameter is present
        while( nWide > s.length ) {  // pad with leading spaces
            s=' '+s;
        }
    }
    return(s);
  }

  onUpdateView = () => evt => {
    let startDate, endDate;
    let seletedIDs = this.state.selectedSites.map((sVal, index) => sVal.siteID);
    if(evt.target.value == 'months') {
      startDate = moment().startOf('month');
      endDate = moment().endOf('month');
      this.setState({
        startDate: startDate,
        endDate: endDate
      });
    }else{
      startDate = moment().subtract(6, 'days');
      endDate = moment();
      this.setState({
        startDate: startDate,
        endDate: endDate
      });
    }
    const arrangeBy = evt.target.value
    this.setState({ 
      arrangeBy: arrangeBy,
    });
    const {
      actions: { getDashobardData }
    } = this.props;

    getDashobardData({ graphDateRange: 'dateRange',siteIDs:seletedIDs, startDate:startDate.format("YYYY-MM-DD 00:00:00"),  endDate:endDate.format("YYYY-MM-DD 23:59:59"), arrangeBy:arrangeBy });
  }

  render() {
    const { dashboardData, siteList, selectedSites } = this.state;
    if (dashboardData.graphRecord) {
      BarData = dashboardData.graphRecord;
    } else {
      BarData = [];
    }
    BarData = BarData.map(function (x, y) { 
      if(x.values) {
        let xx = x.label;
        let xy = x.values.map(function(a, b) {
          let ab=a.x; let bb=parseFloat(a.y, 10);
          return {x:ab, y:bb};
        });
        return {label:xx, values:xy}
      }
    });

    let start = this.state.startDate.format("MMMM D, YYYY");
    let end = this.state.endDate.format("MMMM D, YYYY");
    let label = start + " - " + end;
    if (start === end) {
      label = start;
    }
    let buttonStyle = { width: "100%" };

  
    salesAmt = parseFloat(dashboardData.total_sale_amount);
    
    return (
      <AnimatedView>
        <div>
          <div className="panel">
            <div className="row" style={{ marginBottom: "5px" }}>
              <div className="col-md-2">
                <header className="panel-heading">Select Site : </header>
              </div>
              <div className="col-md-8">
                <Picky
                  numberDisplayed={3}
                  options={siteList}
                  value={selectedSites}
                  valueKey="siteID"
                  labelKey="siteName"
                  multiple={true}
                  includeSelectAll={true}
                  includeFilter={true}
                  onChange={this.handleSiteChange}
                  dropdownHeight={200}
                />
              </div>
              <div className="col-md-2">
                <Button
                  bsSize="small"
                  bsStyle="default"
                  onClick={this.handleFilterData}
                >
                  {" "}
                  Filter{" "}
                </Button>
              </div>
            </div>
          </div>
          <div className="row" style={{ marginBottom: "5px" }}>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + (dashboardData.total_sale_amount ?  this.toDollars(salesAmt): 0)}
                statLabel={"Total Sales"}
                icon={<i className="fa fa-dollar" />}
                backColor={"green"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + (dashboardData.total_transactions ? dashboardData.total_transactions : 0)}
                statLabel={"Total Transactions"}
                icon={<i className="fa fa-exchange" />}
                backColor={"violet"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + (dashboardData.total_users ? dashboardData.total_users : 0)}
                statLabel={"Total Users"}
                icon={<i className="fa fa-user" />}
                backColor={"red"}
              />
            </div>
            <div className="col-md-3">
              <StatsCard
                statValue={"" + (dashboardData.voucher_sold ? dashboardData.voucher_sold : 0)}
                statLabel={"Total Voucher Sold"}
                icon={<i className="fa fa-money" />}
                backColor={"blue"}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="panel">
                <div className="row">
                  <div className="col-md-8">
                    <header className="panel-heading">Transactions</header>
                  </div>
                  <div className="col-md-4">
                 
                   <div className="row"  style={{ marginBottom: "10px" }}>
                      <div className="col-md-12">
                        <select
                          name="arrangeBy"
                          className="form-control"
                          value={this.state.arrangeBy}
                          onChange={this.onUpdateView()}
                        >
                          <option key="days" value="days">
                            View by Days
                          </option>
                          <option key="months" value="months">
                            View by Months
                          </option>
                        </select>
                      </div>
                    </div>
                       
                    <div className="row">
                      <div className="col-md-12">
                        <DatetimeRangePicker
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          ranges={this.state.rangesByMonth}
                          onApply={this.handleDateEvent}
                        >
                        
                          <Button className="selected-date-range-btn" style={{display: (this.state.arrangeBy == 'months') ? 'block' : 'none' }}>
                            <div className="pull-left">
                              <i className="glyphicon glyphicon-calendar"/>
                              &nbsp;
                              <span>
                                {label}
                              </span>
                            </div>
                            <div className="pull-right">
                              <i className="fa fa-angle-down"/>
                            </div>
                          </Button>
                        </DatetimeRangePicker>
                      </div>
                    </div>
                   
                   <div className="row">
                      <div className="col-md-12">
                        <DatetimeRangePicker
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          ranges={this.state.ranges}
                          onApply={this.handleDateEvent}
                        >
                        
                          <Button className="selected-date-range-btn" style={{display: (this.state.arrangeBy == 'days') ? 'block' : 'none' }}>
                            <div className="pull-left">
                              <i className="glyphicon glyphicon-calendar"/>
                              &nbsp;
                              <span>
                                {label}
                              </span>
                            </div>
                            <div className="pull-right">
                              <i className="fa fa-angle-down"/>
                            </div>
                          </Button>
                        </DatetimeRangePicker>
                      </div>
                    </div>                    
  

                  </div>
                </div>
                <div className="panel-body sales-chart">
                  {BarData.length > 0 ? (
                    <BarChart
                      groupedBars
                      data={BarData}
                      xAxis={{tickDirection : "diagonal"}}
                      tooltipHtml={this.tooltipBar}
                      width={900}
                      height={400}
                      style={{ width: "100%" }}
                      margin={{ top: 10, bottom: 80, left: 50, right: 10 }}
                    />
                  ) : (
                    "No Data Found ..."
                  )}
                </div>
              </div>
              {/*<WorkProgress />*/}
            </div>
          </div>
        </div>
      </AnimatedView>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/app/views/home/Home.js